<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h3 class="titulo mb-3 ml-2"> Cadastro E-mail </h3>
        <br>
        <h3 class="ml-3">
            Configure abaixo os destinatários que devem receber o e-mail referente a sincronização diária
        </h3>
        <br>
        <v-row>
            <v-col cols="12" md="6">
                <m-text-field label="E-mail:"
                              outlined
                              ref="email"
                              class="required ml-3"
                              placeholder="Informe o e-mail para receber o processo de sincronização do sistema"
                              v-model="email"
                              v-input-filter="[$filters.email]"
                              :rules="[$rules.required]" />
            </v-col>
            <v-col cols="2" class="mt-7">
                <v-btn class="transition" color="primary" rounded @click="inserirEmail(email)">
                    Salvar
                </v-btn>
            </v-col>
        </v-row>
        <h3 class="titulo mb-3 ml-3">Listagem de e-mails cadastrados</h3>
        <v-row>
            <DataTable ref="datatable" url="/painel/log_sincronizacao/load_email"
                       class="mr-4 ml-4"
                       :filter="dtFiltro">
                <template v-slot:items="{item}">
                    <td>{{ item.email }}</td>
                    <td>
                        <v-col xs12>
                            <v-btn icon>
                                <v-icon @click="deletarEmail(item.id)">ol-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </td>
                </template>
            </DataTable>
        </v-row>
        <v-card-text>
            <h3 class="titulo mb-5 ml-2"> CONFIGURAÇÕES </h3>
            <v-row class="align-center ml-5 mb-8 text-center d-flex">
                <ToggleButton class="ml-4 mr-4 align-self-center" :disabled="sincronizacaoRodando" v-model="options.checarBI" :sync="true" :labels="false" color="var(--primary)"></ToggleButton>
                <span class="font-weight-bold text-body-1">Checar BI/SinMobi</span>
                <ToolTip :content="sincronizacaoRodando ? hintsMessages.rodandoBIMessage : hintsMessages.checarBIMessage" icon="mdi-help-circle-outline" max-width="290px" color="black" icon-classes="ml-1" right />
            </v-row>
            <h3 class="titulo mb-5 ml-2"> SINCRONIZAÇÃO MANUAL </h3>
            <v-row class="align-center ml-5 mb-5">
                <v-col cols="5" md="4">
                    <h2 class="mb-3">SINCRONIZAÇÕES</h2>
                </v-col>
                <v-col cols="4" md="4" class="text-center">
                    <h2 class="mb-3">AÇÃO</h2>
                </v-col>
                <v-col class="text-center">
                    <h2 class="mb-3">STATUS</h2>
                </v-col>
            </v-row>
            <v-row class="align-center ml-5 mb-6" v-for="(itens, index) in sincronizacoes" :key="index">
                <v-col cols="5" md="4">
                    <h3 outlined color="primary" :placeholder="itens.nome">{{ itens.nome }}</h3>
                </v-col>
                <v-col cols="4" md="4" class="d-flex justify-center">
                    <v-btn v-if="itens.ativo && (itens.status === 'inativo' || itens.status === 'Falha')" class="transition" color="success" rounded @click="itens.mutex ? syncMutex(itens) : sincronizar(itens)">
                        Executar
                    </v-btn>
                    <v-btn v-else-if="sincronizacaoRodando && !itens.ativo && itens.status === 'desabilitado'" class="transition" color="success" rounded disabled>
                        Aguardando...
                    </v-btn>
                    <v-btn v-else-if="!itens.ativo && (itens.status === 'Sucesso')" class="transition" color="success" rounded disabled>
                        Executado Hoje!
                    </v-btn>
                    <v-btn v-else-if="!itens.ativo && itens.status === 'Em Execução'" class="transition" color="success" rounded disabled>
                        Sincronizando...
                    </v-btn>
                </v-col>
                <v-col cols="4" md="4" class="text-center">
                    <h3 outlined id="FieldNome" color="primary" :placeholder="itens.data">{{ itens.data }}</h3>
                </v-col>
            </v-row>
            <br>
        </v-card-text>
    </v-container>
</template>
<script>
  import { alert, sleep, notification } from '@/plugins/helpers'
  import { ToggleButton } from 'vue-js-toggle-button'
  import { AlertTypes } from '../../plugins/alerts_types'
  export default {
    name: 'SincronizacaoManual',
    components: { ToggleButton },
    data: () => ({
      hintsMessages: {
        checarBIMessage: 'Desligar a configuração de checagem somente nos Domingos e Segundas-Feiras ou qualquer dia após o meio dia.',
        rodandoBIMessage: 'A configuração foi bloqueada pois há uma sincronização manual em andamento.'
      },
      options: {
        checarBI: true
      },
      nm_sync: '',
      sincronizacoes: [
        {
          nome: 'ExpurgoRascunhoCommand',
          status: 'inativo',
          nome_sync: 'expurgopropostas',
          ativo: true,
          data: '',
          mutex: false
        },
        {
          nome: 'BensSyncCommand',
          status: 'inativo',
          nome_sync: 'bens',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'ParentescosSyncCommand',
          status: 'inativo',
          nome_sync: 'parentescos',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'CargosPublicosSyncCommand',
          status: 'inativo',
          nome_sync: 'cargos_publicos',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'GruposDisponiveisSyncCommand',
          status: 'inativo',
          nome_sync: 'gruposdisponiveis',
          ativo: true,
          data: '',
          mutex: true
        }, {
          nome: 'GruposSyncCommand',
          status: 'inativo',
          nome_sync: 'grupos',
          ativo: true,
          data: '',
          mutex: true
        }, {
          nome: 'CaracteristicasGruposSyncCommand',
          status: 'inativo',
          nome_sync: 'caracteristicas_grupos',
          ativo: true,
          data: '',
          mutex: true
        }, {
          nome: 'PoliticaVendaCotasSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_cotas',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'PoliticaVendaPlanosSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_planos',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'PoliticaVendaBensSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_bens',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'PoliticaVendasPrincipalSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_principal',
          ativo: true,
          data: '',
          mutex: true
        }, {
          nome: 'PoliticaVendasSecundariaSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_secundaria',
          ativo: true,
          data: '',
          mutex: true
        }, {
          nome: 'PoliticaVendasLanceSyncCommand',
          status: 'inativo',
          nome_sync: 'politica_vendas_lance',
          ativo: true,
          data: '',
          mutex: false
        }, {
          nome: 'PrecosSyncCommand',
          status: 'inativo',
          nome_sync: 'precos',
          ativo: true,
          data: '',
          mutex: true
        },
        {
          nome: 'InformacoesPropostaClienteSyncCommand',
          status: 'inativo',
          nome_sync: 'sincronizacao_propostas',
          ativo: true,
          data: '',
          mutex: false
        }
      ],
      visualizar: true,
      email: '',
      dtFiltro: {}
    }),
    computed: {
      sincronizacaoRodando () {
        return !!this.sincronizacoes.find((sync) => sync.status === 'Em Execução')
      }
    },
    mounted () {
      this.loadStatus()
    },
    methods: {
      async sincronizar (item) {
        alert({
          text: 'Confirma executar a sincronização selecionada?',
          buttons: {
            'Cancelar': () => true,
            'Sim': async () => {
              await this.$http.post('/painel/sincronizacaoManual/execute', { params: { nome_sincronizacao: item.nome_sync, nome_sync: item.nome, checar_bi: this.options.checarBI } })
              this.loadStatus()
            }
          }
        })
      },
      async syncMutex (item) {
        alert({
          text: 'Tem certeza que deseja executar essa sincronização?\nA Plataforma de Vendas ficará indisponível durante a execução.',
          buttons: {
            'Cancelar': () => true,
            'Executar': async () => {
              await this.$http.post('/painel/sincronizacaoManual/execute', { params: { nome_sincronizacao: item.nome_sync, nome_sync: item.nome, checar_bi: this.options.checarBI } })
              this.loadStatus()
            }
          }
        })
      },
      async loadStatus (silent = false) {
        const self = this
        await this.$http.get(`/painel/sincronizacaoManual/status`, { options: { silent: silent } }).then(res => {
          if (res.data.vazio) {
            res.data.status = [{
              nome_rotina: 'Falso',
              status: 'inativo',
              data_hora_inicio: 'Umdia'
            }]
          }
          const executando = res.data.executando
          res.data.status.map(function (valores) {
            self.sincronizacoes.forEach(sync => {
              if (valores.nome_rotina === sync.nome) {
                sync.status = valores.status
                sync.data = valores.status + ' - ' + valores.data_hora_inicio
                sync.ativo = valores.status === 'Falha'
              }
            })
          })

          if (executando) {
            self.sincronizacoes.forEach(sync => {
              if (sync.status !== 'Em Execução') {
                sync.status = 'desabilitado'
                sync.ativo = false
              }
            })
          } else {
            self.sincronizacoes.forEach(sync => {
              if (sync.status !== 'Sucesso' && sync.status !== 'Falha') {
                sync.data = ''
                sync.status = 'inativo'
                sync.ativo = true
              }
            })
          }
        })
        this.reloadLoadStatus()
      },
      reloadLoadStatus () {
        sleep(3000)
        while (true) {
          if (this.$http) {
            this.loadStatus(true)
            break
          } else {
            sleep(3000)
          }
        }
      },
      inserirEmail (email) {
        if (this.email) {
          alert({
            text: 'Tem certeza que deseja adicionar o email selecionado?',
            buttons: {
              'Cancelar': () => true,
              'Confirmar': () => {
                this.$http.post('/painel/log_sincronizacao/salvar_email', { params: {
                  itens: email
                } }).then(result => {
                  if (result.data.msg) {
                    this.$refs.datatable.reload()
                    notification(AlertTypes.SUCCESS, result.data.msg)
                    this.$refs.email.reset()
                  } else {
                    notification(AlertTypes.ERROR, result.data.Msg_Erro)
                  }
                })
              }
            }
          })
        } else {
          notification('warning', 'Campo obrigatório!')
        }
      },
      deletarEmail (item) {
        alert({
          text: 'Deseja remover o e-mail de recebimentos diários do processo de sincronização do sistema?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.$http.post('/painel/log_sincronizacao/excluir_email', { params: {
                itens: item
              } }).then(result => {
                if (result.data.msg) {
                  this.$refs.datatable.reload()
                  notification(AlertTypes.SUCCESS, result.data.msg)
                  this.$refs.form.reset()
                } else {
                  notification(AlertTypes.ERROR, result.data.Msg_Erro)
                }
              })
            }
          }
        })
      }
    }

  }
</script>
